import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { QuestionHandlerService } from '../services/question-handler.service';

/**
 * Запрещает прямой переход на /process и вход по обновлению страницы.
 * Если вопросы не загружены (нет активного теста), редирект на accessDenied.
 */
export const processGuard: CanActivateFn = () => {
  const questionHandler = inject(QuestionHandlerService);
  const router = inject(Router);
  if (questionHandler.questions?.length) {
    return true;
  }
  router.navigate(['accessDenied']).then();
  return false;
};
